<template>
  <div class="transition">
    <BasicText size="h5">Quel est le type de public concerné ?</BasicText>
    <div class="transition-items">
      <div>
        <BasicCheckbox
          :label="TypePublicLibelle.Interimaire"
          :model-value="props.out === 'Interimaire'"
          @update:model-value="updateOut"
        />

      </div>
      <BasicText>
        La Demande de Réservation de Fonds (DRF) est <br/>uniquement disponible pour le public intérimaire
      </BasicText>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { type TypePublic, TypePublicLibelle } from '@/features/domaine/types/opco';
import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types';

  const props = defineProps<CarteProps<void, Extract<TypePublic, 'Interimaire'>>>()
  const emits = defineEmits<CarteEvents<Extract<TypePublic, 'Interimaire'>>>()

  const updateOut = (value: boolean | null | undefined) => {
    emits('outChanged', value === true, value ? 'Interimaire' : undefined)
  }
</script>
<style lang="less" scoped>
  @import '../../ajouter/cartes/ChoixCarte.less';
</style>
